// React 컴포넌트: 이미지 업로드 + 프롬프트 입력 UI
import { useState } from "react";
import axios from "axios";
import Button from '../common/Button';

export default function Img2ImgUploader() {
  const [file, setFile] = useState(null);
  const [prompt, setPrompt] = useState("제공된 이미지는 OOO 이야.");
  const [resultUrl, setResultUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!file || !prompt) return alert("이미지와 프롬프트를 입력하세요");

    const formData = new FormData();
    formData.append("prompt", prompt);
    formData.append("image", file);

    setLoading(true);
    try {
    //   const res = await axios.post("/rest/common/generate", formData, {
    //     headers: { "Content-Type": "multipart/form-data" },
    //   });
      const res = await axios.post("/rest/common/generate-original", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setResultUrl(res.data.generated_image_url);
    } catch (err) {
      alert("오류 발생: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 space-y-4 style_guide_v2">
        <h3 className="text-xl font-bold">인페인팅 생성</h3>
        <div style={{marginBottom: "10px"}}>
            <input type="file" accept="image/*" onChange={e => setFile(e.target.files[0])} />   
        </div>
        <div className="flexBox" style={{gap: "10px", flexWrap: "no-wrap", alignItems: "center"}}>
            <textarea
                className="w-full p-2 border rounded"
                rows={3}
                placeholder="프롬프트 입력"
                value={prompt}
                onChange={e => setPrompt(e.target.value)}
                style={{flex:1}}
            />
            {/* <button onClick={handleSubmit} className="bg-blue-600 text-white px-4 py-2 rounded btn-hover-b">
                {loading ? "생성 중..." : "이미지 생성하기"}
            </button> */}
            <Button
                type={"hover_mint"}
                width={"160px"}
                disabled={loading}
                onClick={handleSubmit}
            >{loading ? "생성 중..." : "이미지 생성하기"}</Button>
        </div>

        {resultUrl && (
            <div className="mt-4">
            <h3 className="font-semibold">결과 이미지:</h3>
            <img src={resultUrl} alt="result" className="max-w-full mt-2 rounded border" />
            </div>
        )}
    </div>
  );
}